module.exports = __webpack_public_path__ + "static/media/people.826b8051.png";